/**
 * Premium one-time price as shown in the UI (keep in sync with Stripe product).
 * One payment grants 1 year of Premium access — not a recurring subscription.
 */
export const PREMIUM_ANNUAL_PRICE_AMOUNT_LABEL = '119 DKK';

export const PREMIUM_PRICE_SHORT_LABEL = '119 DKK (engangsbetaling)';

/** @deprecated Use PREMIUM_PRICE_SHORT_LABEL */
export const PREMIUM_ANNUAL_PRICE_SLASH_YEAR = PREMIUM_PRICE_SHORT_LABEL;

export const PREMIUM_PRICE_PERIOD_LABEL = 'engangsbetaling · 1 års adgang';

export const PREMIUM_ONE_TIME_NOTE = 'Engangsbetaling — intet abonnement';

export const PREMIUM_PAYMENT_TRUST_LINE =
  'Intet abonnement · Ingen automatisk fornyelse · Sikker betaling';

export const PREMIUM_UPGRADE_CTA_LABEL = `Opgrader til Premium — ${PREMIUM_PRICE_SHORT_LABEL}`;

export const PREMIUM_LANDING_PRICE_LINE = `Premium: ${PREMIUM_PRICE_SHORT_LABEL}`;

/** Compact price line for institution pages and guest upsells. */
export const PREMIUM_KR_YEAR_LABEL = '119 kr. for 1 år';

export const PREMIUM_DECISION_PRICE_LINE = `${PREMIUM_KR_YEAR_LABEL} · Intet abonnement`;

export const PREMIUM_DECISION_CTA_LABEL = 'Se hvorfor scoren ser sådan ud';

export const PREMIUM_GUEST_DECISION_CTA_LABEL = 'Opret konto for at sammenligne';

export const PREMIUM_AUTH_DECISION_CTA_LABEL = 'Lås den fulde sammenligning op';

export const PREMIUM_GUEST_CONTINUE_CTA_LABEL = `Fortsæt — ${PREMIUM_KR_YEAR_LABEL}`;

export const PREMIUM_AUTH_UNLOCK_CTA_LABEL = `Lås op — ${PREMIUM_KR_YEAR_LABEL}`;

export const PREMIUM_DECISION_BODY =
  'Du har det seneste tilsyns scorer. Premium viser observationerne bag tallene, om kvaliteten har holdt, og hvilken institution der står stærkest.';

export const PREMIUM_DECISION_BULLETS = [
  'Observationerne bag scorerne — hvad tilsynet faktisk så',
  'Om kvaliteten har holdt på tværs af tidligere tilsyn',
  'Hvilken institution der står stærkest, og hvad du skal spørge om på besøget',
];

export function getInstitutionDecisionCta({ userTier } = {}) {
  if (userTier === 'guest') {
    return PREMIUM_GUEST_DECISION_CTA_LABEL;
  }
  return PREMIUM_AUTH_DECISION_CTA_LABEL;
}

export function getInstitutionDecisionBody({ institutionName } = {}) {
  if (institutionName) {
    return `Du kan se de seneste scorer for ${institutionName}. Premium viser observationerne, om billedet har holdt, og hvordan stedet står i en sammenligning.`;
  }
  return PREMIUM_DECISION_BODY;
}

export function getUpsellHeadline({ isAuthenticated, feature } = {}) {
  if (!isAuthenticated) {
    if (feature === 'historical_trends' || feature === 'all_reports') {
      return 'Har institutionen altid klaret sig sådan?';
    }
    if (feature === 'related_institutions') {
      return 'Se naboerne — og hvordan de klarer sig';
    }
    if (feature === 'compare') {
      return 'Opret konto for at sammenligne scorerne';
    }
    if (feature === 'decision' || feature === 'qa') {
      return 'Forstå forskellen, før du vælger';
    }
    if (feature === 'map') {
      return 'Se institutionerne i dit nabolag';
    }
    if (feature === 'summary') {
      return 'Læs den fulde analyse';
    }
    return 'Forstå institutionen — ikke kun det seneste tilsyn';
  }

  if (feature === 'historical_trends' || feature === 'all_reports') {
    return 'Lås op: historiske tilsyn og udvikling';
  }
  if (feature === 'related_institutions') {
    return 'Lås op: relaterede institutioner';
  }
  if (feature === 'summary') {
    return 'Lås op: den fulde analyse';
  }
  return 'Lås op: Premium for denne institution';
}

export function getUpsellHook(feature) {
  if (feature === 'historical_trends' || feature === 'all_reports') {
    return 'Se hvordan kvaliteten har udviklet sig over tid — og sammenlign institutioner på historik, ikke kun ét tilsyn.';
  }
  if (feature === 'related_institutions') {
    return 'Sæt institutionen i perspektiv med naboer i samme bydel, når du sammenligner.';
  }
  if (feature === 'compare' || feature === 'decision') {
    return 'Basis viser scorerne for to institutioner. Premium viser observationerne, historikken og hvilken der står stærkest.';
  }
  if (feature === 'qa') {
    return 'Stil spørgsmål til tilsynet, når du skal vælge — hvad du bør spørge om på besøget, og hvad en scoreforskel betyder.';
  }
  if (feature === 'summary') {
    return 'Få den fulde analyse, så du kan sammenligne institutionens styrker og svagheder i dybden.';
  }
  return '119 kr. for 1 år. Intet abonnement. Ingen automatisk fornyelse.';
}
